import styled from "styled-components";

export enum PRESENTATION {
  ADDITION,
  STRIKETHROUGH,
  DEFAULT,
}

interface PriceElementProps {
  presentation: PRESENTATION;
  boldValue: boolean;
  boldType: boolean;
  largeValue: boolean;
  disabledColor: boolean;
}
export const ValueElement = styled.span<PriceElementProps>`
  text-decoration: ${({ presentation }) =>
    presentation === PRESENTATION.STRIKETHROUGH ? "line-through" : "none"};
  white-space: nowrap;

  & .value-element__value {
    font-size: ${({ presentation, largeValue }) => {
      const fontSize = largeValue ? "18px" : "16px";
      return presentation === PRESENTATION.STRIKETHROUGH ? "14px" : fontSize;
    }};
    ${({ disabledColor }) => disabledColor && "color: #a9a9a9;"}
    ${({ boldValue }) => boldValue && "font-weight: 600;"}
  }

  & .value-element__type {
    font-size: 14px;
    ${({ disabledColor }) => disabledColor && "color: #a9a9a9;"}
    ${({ boldType }) => boldType && "font-weight: 600;"}
  }
`;
